var map = {
	"./bunny-lines/1.svg": "d23a",
	"./chin-crease/1.svg": "dad7",
	"./crows-feet/1.svg": "611b",
	"./forehead-lines/1.svg": "687e",
	"./frown-lines/1.svg": "22bb",
	"./marionette-lines/1.svg": "329f",
	"./mouth-frown/1.svg": "c844",
	"./nasolabial-folds/1.svg": "95a3",
	"./neck/1.svg": "163f",
	"./tear-troughs/1.svg": "6a91",
	"./vertical-lip-lines/1.svg": "a066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5ca";